module.exports = __webpack_public_path__ + "assets/img/icon1.ba5c1b7e.png";